export default __webpack_public_path__ + "img/qr-code.a0afeb33.jpg";